import { useEffect } from "react";

/**
 * Hook to fetch direction data for a specific site, height, and time
 * @param {number} siteIndex - Index of the site
 * @param {number} height - Height value
 * @param {number} time - Time value
 * @param {function} setDirections - Function to set directions
 * @param {object} cachedData - Cached data object
 */
function useFetchDirections(siteIndex, height, time, setDirections, cachedData) {
    useEffect(() => {
        // Only try to get directions if all required cached data is available
        if (cachedData && 
            cachedData[siteIndex] && 
            cachedData[siteIndex][height] && 
            cachedData[siteIndex][height][time] &&
            cachedData[siteIndex][height][time].directions) {
            console.log(`Using cached directions for site ${siteIndex}, height ${height}, time ${time}`);
            setDirections(cachedData[siteIndex][height][time].directions);
        }
    }, [siteIndex, height, time, cachedData, setDirections]);
}

export default useFetchDirections;